// src/project/data/fetches/riderPurchases.js
import { buildUrlWithAuth, RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'

export default {
  url() {
    const userId = getUserId()
    // V3 : /product/list/buyings?group=ultraxeno&userId=... (filter by userId)
    return buildUrlWithAuth(RIDER_ENDPOINTS.PRODUCT_BUYINGS, userId ? { userId } : {})
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Found", count: N, data: [ { id, userId, productId, status, totalPrice, quantity, currency, ... } ] }
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors de la récupération des achats',
        data: [],
      }
    }
    // L'API retourne un tableau directement dans data
    const items = Array.isArray(raw?.data) ? raw.data : raw?.data?.data || []
    return {
      statusCode: 200,
      message: 'Ok',
      data: items.map((item) => ({
        id: item.id,
        productId: item.productId,
        productName: item.productName || item.name || '',
        quantity: item.quantity || 1,
        unitPrice: item.unitPrice || 0,
        totalPrice: item.totalPrice || 0,
        currency: item.currency || 'XOF',
        status: item.status,
        createdAt: item.createdAt,
        expiresAt: item.expiresAt,
      })),
    }
  },
}
